var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiamondWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDiamondWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscriptions-updated-on-11022022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purchases",
    transform: "translate(-314.000000, -112.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-3.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(251.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDiamondWhite",
    transform: "translate(67.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "12.597352 2.94678944 12.591949 2.95286717 6.29867598 10 0 2.94678944"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 2.94678944 2.09755756 0 4.19511511 2.94678944"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "4.19511511 2.94678944 6.29237251 0 8.38993006 2.94678944"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "8.38993006 2.94678944 10.4874876 0 12.5850452 2.94678944 10.4871875 2.94678944"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "2.09755756 0 6.29237251 0 10.4874876 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "4.19511511 2.94678944 6.29867598 10 8.38993006 2.94678944"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiamondWhite);
export default __webpack_public_path__ + "static/media/icDiamondWhite.c97d06f24af9db260b1d15044e00d005.svg";
export { ForwardRef as ReactComponent };